import {classList, dataset, listen} from 'nuffjs';
import {CollapsableHeader} from './collapsable-header';

const ESC_KEYCODE = 27;

const conf = Object.assign({}, CollapsableHeader.conf, {
	searchActiveClass: 'searchActive',
	searchBoxAttr: 'searchBox',
});

class HeaderWithSearch extends CollapsableHeader {
	static conf = conf;
	static defaultOpts = Object.assign({}, CollapsableHeader.defaultOpts, {
		outInterval: 100,
		emptyOnBlur: true,
	});

	outTimeout = null;
	insideSearchBox = false;

	firstConnectedCallback() {
		this.searchBox = this.querySelector(dataset.selector(conf.searchBoxAttr));
		super.firstConnectedCallback();
		if (this.searchBox) {
			this.inputs = this.searchBox.querySelectorAll('input[type="text"],input[type="search"]');
		}
	}

	initListeners() {
		super.initListeners();
		if (this.searchBox) {
			this.listeners.push(listen(this.searchBox, 'focusin', this.onFocusInSearch.bind(this)));
			this.listeners.push(listen(this.searchBox, 'focusout', this.onFocusOutSearch.bind(this)));
			this.listeners.push(
				listen(this.searchBox, 'keydown', this.onKeyPress.bind(this), {selector: 'input'})
			);
		}
	}

	onKeyPress(event) {
		if (event.which === ESC_KEYCODE) {
			event.target.blur();
		}
	}

	onFocusInSearch(event) {
		if (this.outTimeout) {
			clearTimeout(this.outTimeout);
			this.outTimeout = null;
		}
		console.log('focus in', this.searchBox);
		this.toggleInSearchBox(true);
	}

	onFocusOutSearch(event) {
		this.outTimeout = setTimeout(() => this.toggleInSearchBox(false), this.opts.outInterval);
	}

	toggleInSearchBox(isIn) {
		if (isIn !== this.insideSearchBox) {
			this.insideSearchBox = isIn;
			classList(this).toggle(conf.searchActiveClass, isIn);
			if (!isIn && this.opts.emptyOnBlur) {
				for (const input of this.inputs) {
					input.value = '';
					const event = new Event('input', {bubbles: true});
					input.dispatchEvent(event);
				}
			}
		}
	}
}

export {HeaderWithSearch};
